import type { CreateTarget } from "@/features/standalone-versions";
import { CardContent } from "@components/ui/card";
import Input from "@components/ui/input";
import { CreateStoryFolders } from "./create-story-folders";

export const CreateStoryBody = ({
  name,
  setName,
  folder,
  setFolder,
  withFolder,
  createTarget = "story",
}: {
  name: string;
  setName: (name: string) => void;
  folder: { id: string; name: string };
  setFolder: (folder: { id: string; name: string }) => void;
  withFolder: boolean;
  createTarget?: CreateTarget;
}) => {
  return (
    <CardContent>
      <span className="tw-mb-1 tw-block tw-font-sans tw-text-sm tw-font-medium tw-text-blue">
        Name
      </span>
      <Input
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder={
          createTarget === "version"
            ? "Add your version name here..."
            : "Add your story name here..."
        }
        className="tw-h-9 tw-rounded-lg tw-px-3 tw-font-sans tw-text-base tw-font-normal"
      />
      {withFolder && (
        <>
          <span className="tw-mb-1 tw-block tw-font-sans tw-text-sm tw-font-medium tw-text-blue tw-mt-4">
            Folder
          </span>
          <CreateStoryFolders folder={folder} setFolder={setFolder} />
        </>
      )}
    </CardContent>
  );
};
